import moment from 'moment';
import SchoolHeaderImg from '@/assets/svg/headers/schoolHeader.svg';
import logo from '@/assets/svg/geniuslogo.svg';

function dayOrdinal(day) {
  const j = day % 10;
  const k = day % 100;
  if (j === 1 && k !== 11) return `${day}st`;
  if (j === 2 && k !== 12) return `${day}nd`;
  if (j === 3 && k !== 13) return `${day}rd`;
  return `${day}th`;
}

/** Formats ISO  */
function formatEventDateTime(value) {
  if (!value?.trim()) return '';
  const m = moment(value);
  if (!m.isValid()) return value.trim();
  return `${m.format('h:mma')}, ${dayOrdinal(m.date())} ${m.format('MMM')}, ${m.format('YYYY')}`;
}

function buildEventInfoLine(data) {
  if (!data) return '';

  const datePart = formatEventDateTime(data.event_scheduled_date_time);
  const level = data.level?.trim();
  const round = data.round?.trim();
  const mode = data.event_mode?.trim();

  const levelRound =
    level && round ? `${level} - ${round}` : level || round || '';

  return [datePart, levelRound, mode].filter(Boolean).join(' | ');
}

const SchoolHeader = ({ data }) => {
  const eventInfo = buildEventInfoLine(data);

  return (
    <div className="Mathheader">
      {' '}
      <img src={logo} className="SchoolheaderLogo schoolheader " alt="LOGO" />
      <img style={{ width: '100%' }} src={SchoolHeaderImg} alt="Header" />
      <p className="SR_SchoolName">{data?.school_name}</p>
      {eventInfo ? <p className="SR_Eventinfo">{eventInfo}</p> : null}
      <p className="SR_EventName">{data?.event_name} Report</p>
    </div>
  );
};

export default SchoolHeader;
